export default __webpack_public_path__ + "static/media/benefitsBottomBlur.9557214f.png";